const initialState = {}

const adminsTab = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'ADMINS_TAB.INIT':
      return {...state, ...payload}
    default:
      return state
  }
}

export default adminsTab
